import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { theme } from "@meiden-connect/ui";
import { dark, light } from "@meiden-connect/ui/default-theme";
import { App } from "./app";
import { initializeWebConfig } from "./env";
import { loadDashboardThemePreference } from "./theme/theme-preference";
import "./styles.css";

// アプリ起動時にランタイム config と UI テーマを初期化してから React をマウントする。
// TOP ページはライト/ダーク対応、キャンバスページは別途ライト固定へ戻す。
async function bootstrap(): Promise<void> {
  const container = document.getElementById("root");
  if (!container) {
    throw new Error("#root 要素が見つかりません");
  }
  const root = createRoot(container);

  theme.init({ dark, light });
  theme.setPreference(loadDashboardThemePreference());
  try {
    await initializeWebConfig();
  } catch (e) {
    console.error("[bootstrap] WebConfig の初期化に失敗しました", e);
    root.render(
      <StrictMode>
        <div className="bootstrap-error" role="alert">
          アプリケーション設定の読み込みに失敗しました。再読み込みをお試しください。
        </div>
      </StrictMode>
    );
    return;
  }
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

void bootstrap();
